import { Autocomplete, TextField } from '@mui/material';

/** Stored as enum name string on Subscription (Domain PaymentOccurrence). */
export const PAYMENT_OCCURRENCE_OPTIONS = [
  { value: 'Monthly', label: 'Havi' },
  { value: 'Yearly', label: 'Éves' },
  { value: 'Custom', label: 'Egyedi' },
] as const;

type Props = {
  value?: string | null;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
};

const PaymentOccurrenceSelect = ({
  value,
  onChange,
  label = 'Fizetési gyakoriság',
  disabled = false,
  required = false,
}: Props) => {
  const selected =
    PAYMENT_OCCURRENCE_OPTIONS.find((o) => o.value === value)?.value ??
    'Monthly';

  return (
    <Autocomplete
      options={PAYMENT_OCCURRENCE_OPTIONS.map((o) => o.value)}
      getOptionLabel={(v) =>
        PAYMENT_OCCURRENCE_OPTIONS.find((o) => o.value === v)?.label ?? v
      }
      value={selected}
      disabled={disabled}
      onChange={(_e, next) => onChange(next || 'Monthly')}
      renderInput={(params) => (
        <TextField {...params} label={label} required={required} fullWidth />
      )}
    />
  );
};

export default PaymentOccurrenceSelect;
